module.exports = __webpack_public_path__ + "static/media/10_tn.408d44e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/thumbnails/10_tn.jpg
// module id = 440
// module chunks = 0